import { Navigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

function useAuthTokenCheck() {

    const isTokenExpired = (token) => {
        if (!token) {
            return true;
        }

        const decoded = jwtDecode(token);
        const currentTime = Date.now() / 1000;

        return decoded.exp < currentTime;
    };

    const logoutUser = () => {
        localStorage.removeItem('jwtToken');
        // navigate('/login'); 
        <Navigate to = "/login" />
    };

    const checkTokenAndHandleExpiration = () => {
        const token = localStorage.getItem('jwtToken');
        if (token) {
            if (isTokenExpired(token)) {
                logoutUser();
                alert('Session Expired');
            }
        }
    };

    return { checkTokenAndHandleExpiration };
}

export default useAuthTokenCheck;